// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Busca_GeralResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /busca/geral?q=
 *
 * Typed hits across clientes, orçamentos, compromissos and ordens de serviço,
 * grouped in that order, at most 20 per type. @see Busca_GeralRow
 */
import type { Busca_GeralRow } from './Busca_GeralRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Busca_GeralResponseDados = Busca_GeralRow[];

export type Busca_GeralResponse = ApiResponse<Busca_GeralResponseDados>;

registerResponseContract('Busca_GeralResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      tipo:            { type: 'string',  required: true },
      id:              { type: 'number',  required: true },
      titulo:          { type: 'string',  required: true },
      subtitulo:       { type: 'string',  required: false },
      status:          { type: 'string',  required: false },
      status_raw:      { type: 'string',  required: false },
      franquia:        { type: 'string',  required: false },
      franquia_id:     { type: 'number',  required: false },
      matched_field:   { type: 'string',  required: false },
      matched_value:   { type: 'string',  required: false },
      cliente_id:      { type: 'number',  required: false },
      cliente_nome:    { type: 'string',  required: false },
      matched_item_id: { type: 'number',  required: false },
    },
  },
})
